<template>
  <div
    class="lesson__content"
    :class="{ '-user-': !isAdmin }"
  >
    <template
      v-for="(part, partIdx) in storeParts"
      v-if="!gettingLesson"
    >
      <ul
        v-if="part.blocks.length === 0"
        :key="partIdx"
        class="lesson__list"
      >
        <li class="lesson__item -empty-">
          <AddBlockRow
            :block="{}"
            :part-id="part.id"
          />
        </li>
      </ul>
      <transition-group
        v-else-if="storeParts.length !== 0"
        :key="'lesson__list' + partIdx"
        class="lesson__list"
        name="list"
        tag="ul"
      >
        <li
          v-for="(block, idx) in part.blocks"
          :key="'' + block.id + block.type + block.variety"
          class="lesson__item"
        >
          <component
            :is="getBlock(block)"
            :content="block.content"
            :is-first-block="idx === 0"
            :is-last-block="idx === part.blocks.length - 1"
            :is-loading="idx === isLoadingBlockIdx"
            :permissions="$permissions"
            @saveBlock="saveBlock($event, { block, partId: part.id, idx })"
            @saveBlockWithGet="saveBlockWithGet($event, { block, partId: part.id, idx })"
            @deleteBlock="deleteBlockCall({ block, partId: part.id })"
            @moveUp="moveUpBlockCall({ block, partId: part.id, idx })"
            @moveDown="moveDownBlockCall({ block, partId: part.id, idx })"
            @duplicateBlock="duplicateBlockCall({ block, partId: part.id, idx })"
          />
          <AddBlockRow
            v-if="$permissionsCreate"
            :block="block"
            :part-id="part.id"
          />
        </li>
      </transition-group>
      <MainAsideRight
        :key="partIdx"
        :is-open="asideIsOpen"
        store-path="coursesLesson"
      >
        <Aside />
      </MainAsideRight>
    </template>
    <template v-else>
      <ul class="lesson__list">
        <li
          v-for="(block, idx) in 5"
          :key="idx"
          class="lesson__item"
        >
          <div class="lesson-block main-block">
            <div class="lesson-block__content -ajax-">
              <div class="lesson-block__ajax ajax__line" />
              <div class="lesson-block__ajax ajax__line" />
            </div>
          </div>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ButtonComponent from '../../components/Button/ButtonIsAdmin';
import FilesComponent from '../../components/Files/FilesIsAdmin';
import ImageComponent from '../../components/Image/ImageIsAdmin';
import TaskComponent from '../../components/Task/TaskIsAdmin';
import TextComponent from '../../components/Text/TextIsAdmin';
import TitleComponent from '../../components/Title/TitleIsAdmin';
import VideoComponent from '../../components/Video/VideoIsAdmin';
import TestFranchComponent from '../../components/TestFranch/TestIsAdmin/index';
import TaskCorrectFranchComponent from '../../components/TaskCorrectFranch/IsAdmin';
import TaskTeamFranchComponent from '../../components/TaskTeamFranch/IsAdmin';
import MotionCalculatorComponent from '../../components/MotionCalculator/MotionCalculatorIsAdmin';

import AddBlockRow from '../../components/AddBlockRow';

import MainAsideRight from '@/components/MainAsideRight';
import Aside from '../Aside';

export default {
  components: {
    ButtonComponent,
    FilesComponent,
    ImageComponent,
    TaskComponent,
    TextComponent,
    TitleComponent,
    VideoComponent,
    AddBlockRow,
    Aside,
    MainAsideRight,
    TestFranchComponent,
    TaskCorrectFranchComponent,
    TaskTeamFranchComponent,
    MotionCalculatorComponent
  },
  props: ['isAdminProp'],
  data: () => ({
    isLoadingBlockIdx: null
  }),
  computed: {
    ...mapState('coursesLesson', {
      storeParts: s => s.data.parts,
      isStoreLoading: s => s.meta.isLoading,
      gettingLesson: s => s.meta.gettingLesson,
      asideIsOpen: s => s.aside.meta.isOpen
    }),
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.lessonModuleAdmin
    })
  },
  watch: {
    storeParts() {
      this.getBlock();
    },
    $route() {
      const isLesson = /\/courses\/lesson/.test(this.$route.path);

      if (isLesson) {
        this.getLesson();
      }
    }
  },
  mounted() {
    document.querySelector('html').scrollTop = 0;
  },
  methods: {
    ...mapActions('coursesLesson', [
      'getLesson',
      'getAndUpdateLessonBlock',
      'editLessonsBlock',
      'deleteBlock',
      'moveBlockUp',
      'moveBlockDown',
      'duplicateBlock'
    ]),

    getBlock(block) {
      if (!block) {
        return;
      }

      let blockName;

      if (block.type === 1) {
        switch (block.variety) {
        case 1:
          blockName = 'title';
          break;
        case 2:
          blockName = 'text';
          break;
        case 3:
          blockName = 'video';
          break;
        case 4:
          blockName = 'image';
          break;
        case 6:
          blockName = 'files';
          break;
        case 7:
          blockName = 'button';
          break;
        default:
          console.error(`Undefined block.variety = ${block.variety}`);
          return false;
        }
      } else if (block.type === 2) {
        switch (block.variety) {
        case 1:
          blockName = 'Task';
          break;
        default:
          console.error(`Undefined block.variety = ${block.variety}`);
          return false;
        }
      } else if (block.type === 4) {
        switch (block.variety) {
        case 2:
          blockName = 'Test-franch';
          break;
        default:
          console.error(`Undefined block.variety = ${block.variety}`);
          return false;
        }
      } else if (block.type === 5) {
        switch (block.variety) {
        case 2:
          blockName = 'Task-correct-franch';
          break;
        default:
          console.error(`Undefined block.variety = ${block.variety}`);
          return false;
        }
      } else if (block.type === 6) {
        switch (block.variety) {
        case 2:
          blockName = 'Task-team-franch';
          break;
        default:
          console.error(`Undefined block.variety = ${block.variety}`);
          return false;
        }
      } else if (block.type === 7) {
        switch (block.variety) {
        case 1:
          blockName = 'Motion-calculator';
          break;
        default:
          console.error(`Undefined block.variety = ${block.variety}`);
          return false;
        }
      }

      if (blockName) {
        return `${blockName}-component`;
      }
    },

    async saveBlock(event, { block, partId, idx }) {
      block.content = event;
      await this.setLoading(idx);

      await this.editLessonsBlock({ block, partId });

      await this.setLoading(null);
    },

    async saveBlockWithGet(event, { block, partId, idx }) {
      block.content = event;
      await this.setLoading(idx);

      await this.editLessonsBlock({ block, partId });

      await this.getAndUpdateLessonBlock({ block, partId });

      await this.setLoading(null);
    },

    deleteBlockCall({ block, partId }) {
      block.blockId = block.id;
      this.deleteBlock({ block, partId });
    },

    moveUpBlockCall({ block, partId }) {
      this.moveBlockUp({ block, partId });
    },

    moveDownBlockCall({ block, partId }) {
      this.moveBlockDown({ block, partId });
    },

    duplicateBlockCall({ block, partId }) {
      this.duplicateBlock({ block, partId });
    },

    setLoading(idx) {
      this.isLoadingBlockIdx = idx;
    }
  }
};
</script>

<style lang="scss" scoped>
.lesson__item {
  margin: 24px 0;
}
</style>
